<template>
	<div class="row">
		<div class="col-12">
			<div class="row">
				<div class="col-md-12 titulo-paso">No Invoiceables (Obligatorio)</div>
			</div>
			<div class="row">
				<div class="col-12 text-right">
					<b-button id="seguir" variant="success" v-on:click="seguir">SEGUIR</b-button>
					<hr />
				</div>
			</div>
			<div class="row">
				<div class="col-10">
					<label class="control-label">A continuación: ingrese el monto no facturable</label>
					<b-input type="number" size="sm" v-model="monto" />
				</div>
			</div>
		</div>
	</div>
</template>
<script lang="ts">

	import axios from "axios"


	export default 
	{
		name: "Paso4",
		props: {
			periodo: "",
			confirmacion: false,
			onAvanzar: Function, // Funcion callback para la accion de avanzar en el wizard
			onArchivo: Function, // Funcion callback para informar sobre el archivo cargado
		},
		data() {
			return {
				monto: 0,
			}
		},
		methods: {

			// Procesamos la data para pasar al Paso 5
			seguir() {

				// Mostramos la imagen "cargando"
				window.event.$emit("mostrar-cargando", true)

				// Estructura con la info que se enviara al servidor
				var request = {
					"usuario": this.$usuario, 
					"destino": this.$env,
					"tx": "F0",
					"proceso": "upDataFac",
					"archivo": "no_invoiceable",
					"periodo": this.periodo,
					"data": [ { "no_invoiceable": this.monto } ] 
				}	

				// Llamada a la API
				axios.post("/face", request, { headers: { "Content-Type": "text/plain" } }).then(response => {

					// Llamamos a la funcion callback
					if (response.data.estatus == "OK") {

						if (this.onAvanzar) 
							this.onAvanzar()

					} else
						 alert("No se pudo enviar")

				}).catch(ex => {

					// Si hubo un error, pasamos por aca y lo registramos
					console.log(ex.message)
				})

				// Ocultamos la imagen "cargando"
				window.event.$emit("mostrar-cargando", false)
			}
		}
	}

</script>
<style scoped>
</style>
